module.exports = __webpack_public_path__ + "img/app.0202af73.png";